import bg1 from '../assets/images/cavenuesgrant/cavenuesgrant-background.png';

const roundData = {
  closeDate: '2021-12-08T01:00:00.000+00:00',
  notificationDate: '2021-12-13T08:00:00.000+00:00',
  openDate: '2021-10-29T16:00:00.000+00:00',
};

const buttonText = {
  applyButtonText: 'Apply Now',
  loginButtonText: 'Login',
};

const programGuideLineButtons = [
  {
    text: 'CA Venues Website',
    link: 'http://www.cavenuesgrant.com/',
  },
  {
    text: 'Required Documents',
    link: 'https://cavenuesgrant.com/#required-documents',
  },
  {
    text: 'Eligibility Requirements',
    link: 'https://cavenuesgrant.com/#eligibility',
  },
  {
    text: 'Application Guide',
    link: 'https://cavenuesgrant.com/#application-guides',
  },
  {
    text: 'FAQs',
    link: 'https://cavenuesgrant.com/faq/',
  },
];

const productType = 'VENUES_GRANT';
const maxLoanAmount = 250000;

const IDCardDetails = [
  "Application Certification (Download Form <a href='/CA Venues_For-Profit_Application Certifications.pdf' target='blank'>For-profits here</a> or <a href='/CA Venues_Nonprofit_Application Certifications.pdf' target='blank'>for Non-profits here</a>)",
  'Government Issued Photo ID',
  'Complete 2019 Federal Tax Return and California Tax Return',
  'Complete 2020 Federal Tax Return and California Tax Return',
  'Interim Financials (2019 Cumulative Q2, Q3 and Q4 Profit & Loss Statements)',
  'Interim Financials (2020 Cumulative Q2, Q3 and Q4 Profit & Loss Statements)',
  'Most Recent IRS Exemption Letter (Non-profits only)',
];

const docsDetails = [
  '(One of the Following): Articles of Incorporation, Certificate of Organization, Fictitious Name of Registration, or Government-Issued Business License',
  'Bank Verification',
];

const helpfulTips = ['Disable your pop-up blocker', 'Please use Google Chrome'];

const landingDetails = {
  backgroundImage: bg1,
  className: 'smbcontractor',
  status: 'OPEN',
  subTitle: 'Financing',
  title: 'Illinois B2B Startup',
};

export default {
  roundData,
  programGuideLineButtons,
  productType,
  maxLoanAmount,
  IDCardDetails,
  docsDetails,
  helpfulTips,
  landingDetails,
  buttonText,
};
